// API Models

export enum PharmOrderStatus {
  NeedsConsent = 'Needs Consent',
  ReadyToAuthorize = 'Ready to Authorize',
  ReadyToShip = 'Ready to ship',
  Shipped = 'Shipped',
  Cancelled = 'Cancelled',
  ToEarlyToFill = 'Too Early to Fill',
  Pending = 'Pending',
}

export interface ApiPharmOrderResponse {
  enterpriseOrderId: string;
  orderNumber: string;
  shipBy: string;
  trackingNumber: string;
  pharmacyLocation: string;
  orderStatus: string;
  customerAddressId: string;
  customerId: string;
  source: string;
  items: PharmItem[];
}

export interface PharmItem {
  rxNumber: number;
  drugDescription: string;
  quantity: number;
}

export type ApiGetPharmOrderResponse = ApiPharmOrderResponse[];

export interface ApiPharmOrderRequest {
  enterpriseOrderId?: string;
  orderNumber?: string;
  shipBy?: string;
  trackingNumber?: string;
  pharmacyLocation?: string;
  orderStatus?: string;
  customerAddressId: string;
  customerId: string;
  source: string;
  items?: ApiPharmItemRequest[];
}

export interface ApiPharmItemRequest {
  rxNumber?: number;
  drugDescription?: string;
  quantity?: number;
}

// Front End Models

export interface PharmOrder {
  enterpriseOrderId: string;
  orderNumber: string;
  shipBy: string;
  trackingNumber: string;
  pharmacyLocation: string;
  orderStatus: string;
  customerAddressId: string;
  customerId: string;
  source: string;
  items: PharmItem[];
}

export interface UpdatePharmOrderForm extends ApiPharmOrderRequest {}

// Mappers

export const mapPharmOrder = (p: ApiPharmOrderResponse): PharmOrder => {
  return {
    ...p,
    enterpriseOrderId: p.enterpriseOrderId,
    orderNumber: p.orderNumber,
    shipBy: p.shipBy,
    trackingNumber: p.trackingNumber,
    pharmacyLocation: p.pharmacyLocation,
    orderStatus: p.orderStatus,
    customerAddressId: p.customerAddressId,
    customerId: p.customerId,
    source: 'Portal',
    items: p.items,
  };
};
